import {MarkdownEditHistoryMetadataServerQuery} from '@github-ui/server-persisted-queries'
import type {MarkdownEditHistoryMetadataServerQueryQuery} from '@github-ui/server-persisted-queries/types/MarkdownEditHistoryMetadataServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

type QueryNode = NonNullable<MarkdownEditHistoryMetadataServerQueryQuery['node']>

export type MarkdownEditHistoryMetadata = Extract<QueryNode, {viewerCanReadUserContentEdits: boolean}>

function isMarkdownEditHistoryMetadata(node: QueryNode): node is MarkdownEditHistoryMetadata {
  return 'viewerCanReadUserContentEdits' in node && typeof node.viewerCanReadUserContentEdits === 'boolean'
}

export function markdownEditHistoryMetadataQueryKey(commentId: string) {
  return ['markdown-edit-history-viewer', 'metadata', commentId] as const
}

export async function fetchMarkdownEditHistoryMetadata(
  commentId: string,
  signal?: AbortSignal,
): Promise<MarkdownEditHistoryMetadata | null> {
  const response = await reactFetchJSON(
    `/user_content_edits/edit_history_metadata/${encodeURIComponent(commentId)}?queryId=${MarkdownEditHistoryMetadataServerQuery}`,
    {signal},
  )
  if (!response.ok) throw new Error(`Edit history metadata fetch failed (${response.status})`)

  const json = (await response.json()) as {data?: MarkdownEditHistoryMetadataServerQueryQuery; errors?: unknown[]}
  if (!json.data) throw new Error('Edit history metadata query returned no data')

  const node = json.data.node
  return node && isMarkdownEditHistoryMetadata(node) ? node : null
}
